/**
 * Basic Registration saga functions
 */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';
import InviteTokenAPI from '../../Lib/Api/invite-token';

const { Auth } = Constants;
const {
  signupError,
  signupSuccess,
  verifyInviteTokenError,
  verifyInviteTokenSuccess,
} = Actions;

/**
 * Signs up user and dispatches success or error
 *
 * @param {object} action action object containing type and sign up form data
 */
export function* signup(action) {
  const { resolve, reject } = action;
  try {
    const response = yield call(UserAPI.signup, action.formData);
    yield put(signupSuccess(response));
    yield call(resolve, response);
  } catch (err) {
    yield handleError(signupError, err);
    yield call(reject, err);
  }
}

/**
 * Fetches access token and dispatches success or error
 *
 * @param {string} token access token
 */
export function* verifyInviteToken({ token }) {
  try {
    const { record } = yield call(InviteTokenAPI.verify, token);
    yield put(verifyInviteTokenSuccess({ token, retrievedToken: record }));
  } catch (err) {
    yield handleError(verifyInviteTokenError, err);
  }
}

/**
 * Allows multiple requests to sign up
 * Gets the latest response to get access token
 */
export function* basicRegistrationSaga() {
  yield all([
    yield takeLatest(Auth.SIGNUP, signup),
    yield takeLatest(Auth.VERIFY_INVITE_TOKEN, verifyInviteToken),
  ]);
}

export default basicRegistrationSaga;
